import { Injectable } from '@angular/core';

interface ScrollAnchorSync {
  threadId: string | null;
  hasMessages: boolean;
  host: HTMLElement;
  spacer: HTMLElement;
}

@Injectable()
export class TellentAssistantScrollAnchorService {
  private threadId: string | null = null;
  private active = false;
  private pendingScroll = false;

  public arm(): void {
    this.active = true;
    this.pendingScroll = true;
  }

  public sync({ threadId, hasMessages, host, spacer }: ScrollAnchorSync): void {
    if (threadId !== this.threadId) {
      this.threadId = threadId;
      this.active = false;
      this.pendingScroll = false;
      spacer.style.height = '0px';
      return;
    }
    if (!this.active || !hasMessages) return;
    const scroll = this.pendingScroll;
    this.pendingScroll = false;
    requestAnimationFrame(() => this.apply(host, spacer, scroll));
  }

  private apply(host: HTMLElement, spacer: HTMLElement, scroll: boolean): void {
    const prompts = host.querySelectorAll<HTMLElement>('.role-user');
    const prompt = prompts[prompts.length - 1];
    if (!prompt) return;
    const messages = <HTMLElement>spacer.parentElement;
    const contentBelow = messages.scrollHeight - spacer.offsetHeight - prompt.offsetTop;
    const reserve = Math.max(0, host.clientHeight - contentBelow);
    spacer.style.height = `${reserve}px`;
    if (scroll) {
      const top =
        prompt.getBoundingClientRect().top - host.getBoundingClientRect().top + host.scrollTop;
      host.scrollTo({ top, behavior: 'smooth' });
    }
  }
}
